module.exports = __webpack_public_path__ + "img/bg02.2aed85d2.png";